import { notification } from 'antd';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const createApiService = () => {
    const service = axios.create({
        baseURL: process.env.REACT_APP_BASE_API,
        timeout: 30000
    });

    service.interceptors.request.use(
        (config: AxiosRequestConfig) => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString)
            if (config.headers != null) {
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                config.headers['Content-Type'] = 'application/json';
                config.headers.Authorization = `token ${urlParams.get('token')}`;
                config.headers.ClientId = process.env.REACT_APP_CLIENT_ID;
                config.headers.AppCode = process.env.REACT_APP_CODE;
                config.headers.CompanyId = urlParams.get('company');
            }

            return config;
        },
        (error: any) => {
            return Promise.reject(error);
        }
    );

    service.interceptors.response.use(
        (response: AxiosResponse) => {
            return response.data;
        }, (error: any) => {
            notification.error({
                message: 'Desculpe ocorreu um erro!'
            })
            return Promise.reject(error);
        }
    );

    return service;
}